import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-bo-auth-phone-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './bo-auth-phone-input.component.html',
  styleUrls: ['./bo-auth-phone-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthPhoneInputComponent {
  readonly inputId = input.required<string>();
  readonly label = input.required<string>();
  readonly codeControl = input.required<FormControl>();
  readonly phoneControl = input.required<FormControl>();
  readonly codeOptions = input.required<readonly string[]>();
  readonly phonePlaceholder = input('+57 ...');
  readonly phoneAriaLabel = input('');
}
